export default {
  FETCH_BLOG_POST_EMAILS_REQUEST: 'FETCH_BLOG_POST_EMAILS_REQUEST',
  FETCH_BLOG_POST_EMAILS_SUCCESS: 'FETCH_BLOG_POST_EMAILS_SUCCESS',
  FETCH_BLOG_POST_EMAILS_FAILURE: 'FETCH_BLOG_POST_EMAILS_FAILURE',
  RESET_BLOG_POST_EMAILS: 'RESET_BLOG_POST_EMAILS'
}
